// extracted by mini-css-extract-plugin
module.exports = {"refLink":"e_bq","refLinkDesktop":"e_cq","titleFont":"e_dq"};